import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  StyledPhotoLabelsContainer,
  StyledPhotoLabelsOverlayContainer,
  PhotoLabel,
  Label,
  Description,
} from './styles';

export const PhotoLabelsOverlay = ({ showAnimation = true, photoLabels }) => {
  const [showLabels, setShowLabels] = useState(() =>
    showAnimation ? [] : photoLabels?.map(() => true) ?? [],
  );
  const timersRef = useRef([]);

  useEffect(() => {
    timersRef.current.forEach(clearTimeout);
    timersRef.current = [];

    if (!showAnimation) {
      setShowLabels(photoLabels?.map(() => true) ?? []);
      return;
    }

    setShowLabels([]);
    photoLabels?.forEach((_, i) => {
      const t = setTimeout(
        () =>
          setShowLabels(prev => {
            const next = [...prev];
            next[i] = true;
            return next;
          }),
        350 + i * 750,
      );
      timersRef.current.push(t);
    });

    return () => timersRef.current.forEach(clearTimeout);
  }, [showAnimation, photoLabels]);

  return (
    <StyledPhotoLabelsOverlayContainer>
      <StyledPhotoLabelsContainer>
        {photoLabels?.map((item, i) => (
          <PhotoLabel
            key={i}
            $top={item.top}
            $left={item.left}
            $topMobile={item.topMobile}
            $leftMobile={item.leftMobile}
            $cornerDotAlignment={item.cornerDotAlignment}
            $show={!!showLabels[i]}
          >
            <Label
              $fontColor={item.labelFontColor}
              $typography={item.labelTypography}
            >
              {item.label}
            </Label>
            <Description
              $fontColor={item.descriptionFontColor}
              $typography={item.descriptionTypography}
            >
              {item.description}
            </Description>
          </PhotoLabel>
        ))}
      </StyledPhotoLabelsContainer>
    </StyledPhotoLabelsOverlayContainer>
  );
};

PhotoLabelsOverlay.displayName = 'PhotoLabelsOverlay';

PhotoLabelsOverlay.propTypes = {
  showAnimation: PropTypes.bool,
  photoLabels: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      labelFontColor: PropTypes.string,
      labelTypography: PropTypes.string,
      description: PropTypes.string,
      descriptionFontColor: PropTypes.string,
      descriptionTypography: PropTypes.string,
      top: PropTypes.number,
      left: PropTypes.number,
      topMobile: PropTypes.number,
      leftMobile: PropTypes.number,
      cornerDotAlignment: PropTypes.oneOf(['left', 'right']),
    }),
  ),
};
